exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table_row_1489c6d{box-sizing:content-box;line-height:36px;border-bottom:1px solid #eaecf0}.table_row_1489c6d:last-child{margin-bottom:0;padding-bottom:0;border:none}", ""]);

// exports
exports.locals = {
	"table_row": "table_row_1489c6d"
};